<template>
  <div>
    <div class="header-wrapper" :class="{ 'is-fixed': isFixed }">
      <div class="header">
        <div class="header-left">
          <img src="@/assets/images/user-rights/logo.png" alt="" />
          <div class="back-home" data-io-click="tracker"  @click="handleBackHome">
            <i class="iconfont icon-home1"></i>
            返回工作台
          </div>
        </div>
        <div class="header-right">
          <img
            v-if="userData && userData.faceImg"
            :src="userData.faceImg"
            alt=""
          />
          <img
            data-io-click="tracker"  @click="toLogin"
            v-else
            src="@/assets/images/user-rights/avator.png"
          />
          <span data-io-click="tracker"  @click="toLogin">{{
            userData && (userData.nickName || userData.loginName)
              ? userData.nickName || userData.loginName
              : "未登录"
          }}</span>
          <div
            class="tip"
            v-if="
              userData && !userData.nickName && !userData.loginName && showTip
            "
          >
            立即登录，获取网校通专属权益
            <i class="el-icon-close" data-io-click="tracker"  @click="handleCloseTip"></i>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="occupy-box"></div> -->
  </div>
</template>
<script>
import util from "@/assets/js/common/util";
import { mapState } from "vuex";
export default {
  inject: ["equity"],
  data() {
    return {
      showTip: false,
      isFixed: false,
      userData: null,
    };
  },
  computed: {
    ...mapState({
      userInfo: "userInfo",
    }),
  },
  watch: {
    userInfo: {
      handler(val, oldVal) {
        // console.log(val, val.nickName, "oldVal----", oldVal);
        if (!oldVal && val && !val.nickName) {
          this.showTip = true;
        }
        if (!oldVal && val) {
          this.userData = JSON.parse(JSON.stringify(val));
        }
      },
      immediate: true,
    },
  },
  mounted() {
    window.addEventListener("scroll", this.scrollHandleDebounce, true);
  },
  destroyed() {
    window.removeEventListener("scroll", this.scrollHandleDebounce, true);
  },
  methods: {
    handleBackHome() {
      this.$router.push("/desktop");
    },
    handleScroll(e) {
      let scrollTop =
        window.pageYOffset ||
        document.body.scrollHeight ||
        document.documentElement.scrollTop;
      this.isFixed = scrollTop > 62;
    },
    scrollHandleDebounce(e) {
      util.throttle(this.handleScroll, 500)(e);
    },
    handleCloseTip() {
      this.showTip = false;
    },
    toLogin() {
      console.log("用户信息", this.userData);
      if (!this.userData.userId) {
        this.equity.loginPopupVisible = true;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.header-wrapper {
  position: fixed;
  z-index: 1000;
  top: 0;
  left: 0;
  width: 100%;
  height: 62px;
  .header {
    width: 1200px;
    margin: 0 auto;
    height: 62px;
    display: flex;
    // align-items: center;
    justify-content: space-between;
    .header-left {
      display: flex;
      align-items: center;
      img {
        width: 116px;
        height: 36px;
      }
      .back-home {
        margin-left: 17px;
        font-size: 14px;
        color: #ccc;
        margin-top: 5px;
        cursor: pointer;
      }
    }
    .header-right {
      display: flex;
      align-items: center;
      font-size: 14px;
      flex: 1;
      justify-content: flex-end;
      color: #fff;
      position: relative;
      img {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        margin-right: 12px;
        cursor: pointer;
      }
      span {
        cursor: pointer;
      }
      .tip {
        position: absolute;
        padding: 5px 5px 5px 8px;
        background: linear-gradient(to right, #ff8c2f, #ff4220);
        font-size: 14px;
        line-height: 22px;
        right: 0;
        bottom: -35px;
        border-radius: 3px;
        i {
          cursor: pointer;
        }
        // position: relative;
        &::after {
          position: absolute;
          display: block;
          content: "";
          width: 0px;
          height: 0px;
          border-left: 5px solid transparent;
          border-right: 5px solid transparent;
          top: -6px;
          right: 23px;
          // border-top: 3px solid transparent;
          border-bottom: 6px solid #ff6327;
        }
      }
    }
  }
  &.is-fixed {
    background: #27292c;
  }
}
.occupy-box {
  height: 62px;
}
</style>
